<template>
  <el-dialog
    title="审核"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="200px"
      size="small"
    >


      <el-form-item
              prop="sh_state"
              label="生平照片是否显示"
      >
        <el-radio v-model="form.is_photo" label="0"  >显示</el-radio>
        <el-radio v-model="form.is_photo" label="1"  >不显示</el-radio>
      </el-form-item>
      <el-form-item label="生前照片" prop="advImg2"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.advImg2"　 style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=100
                :auto-upload="true"
                :file-list="fileList"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove"
                :on-success="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
        </el-upload>
        建议尺寸1000*600像素，大小7M以内，支持jpg、png、jpeg格式
      </el-form-item>


      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >提交</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as oneclassService from "@/api/sys/oneclass";
    import util from '@/libs/util.js'
export default {
  name: "smallposterEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {

    return {
      imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
        formEdit: true,
      loading: false,
      dialogVisible: false,
      fileList: [],
      fileList3: [],
      form: {
        is_photo: '0',
        advImg2: ''
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    handleBeforeUpload(file){
      let isJPG =true;
      // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
      console.log('before');
      if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        isJPG=false;
        this.$notify.warning({
          title: '警告',
          message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
        })

      }
      let size = file.size / 1024 / 1024 / 1
      if(size > 7) {
        this.$notify.warning({
          title: '警告',
          message: '图片大小必须小于7M'
        })
        isJPG=false;
      }

      return isJPG // 返回false不会自动上传
    },
  // 文件列表移除文件时的钩子
  handleRemove(file, fileList) {
    console.log("url222==="+JSON.stringify(fileList));
    this.fileList3=[];
    for (let index = 0; index < fileList.length; index++) {
      if(fileList[index].response!=null){
        console.log("url5555==="+fileList[index].response.url);
        this.fileList3.push(fileList[index].response.url);
      }else{
        console.log("url5555==="+fileList[index].url22);
        this.fileList3.push(fileList[index].url22);
      }
    }
    this.form.advImg2 ="1";
    this.dialogVisible = true;

  },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      console.log("url==="+file.url);
      this.fileList3.push(file.url);
      this.form.advImg2 = "1";
      this.dialogVisible = true;
    },
    dialogOpen() {
      this.$refs.form.resetFields();
      this.fileList=[];
      this.fileList3=[];
      let form = {};
      form.is_photo=this.oneclass.is_photo+"";

      var formData2 = new FormData() // 声明一个FormData对象
      formData2.append('dispose_id',this.oneclass.id)
      agentService.getJzDisposePhoto(formData2).then(data => {
        if(data!=null && data!="") {
          //循环遍历,将穿回来的list转换为chart需要的键值对形式
          for (let index = 0; index < data.length; index++) {
            form.advImg2="1";
            this.fileList3.push(data[index].businessname);
            this.fileList.push({
              url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + data[index].businessname
            });
          }
          this.form = form;
        }else{
          form.advImg2="";
          this.form = form;

        }
      });

    },

    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
                        this.loading = true;
            agentService.saveJzPhotoShDisposePoster({ ...this.form,agentid:util.cookies.get('agentid'), xt_id:util.cookies.get('xt_id'),id:this.oneclass.id,detailsimg:this.fileList3})
                            .then(data => {
                                this.loading = false;
                                this.dialogVisible = false;
                                this.$emit("submit");
                            });


        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

